import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography } from "@mui/material";

const StateSelect = ({ stateRef }) => {
  const stateNames = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
    "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
    "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ];

  return (
    <FormControl fullWidth required>
      <Typography id="state-label" sx={{ color: "white" }}>State*</Typography>
      <Select
        id="state"
        name="state"
        inputRef={stateRef}
        defaultValue=""
        displayEmpty
        size="small"
        required
        sx={{ background: "white", borderRadius: 1 }}
      >
        <MenuItem value="">-- Please Choose a State --</MenuItem>

        {stateNames.map((state, index) => (
          <MenuItem key={index} value={state}>{state}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StateSelect;
